module.exports = __webpack_public_path__ + "img/customer-a-066.eead0a2e.png";